import { render, staticRenderFns } from "./EducationMain.vue?vue&type=template&id=11d730fc&scoped=true&"
import script from "./EducationMain.vue?vue&type=script&lang=js&"
export * from "./EducationMain.vue?vue&type=script&lang=js&"
import style0 from "./EducationMain.vue?vue&type=style&index=0&id=11d730fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d730fc",
  null
  
)

export default component.exports